import Layout from '../Layout/Layout';

interface MenuProps {
  children: React.ReactNode;
}

const Menu = ({ children }: MenuProps): JSX.Element => {
  return <Layout>{children}</Layout>;
};

export default Menu;
